import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import smtpConfig from './Admin/Core/smtpconfig'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import about from './Admin/App/about'
import brands from './Admin/App/brands'
import blogCategories from './Admin/App/blog_categories'
import blog from './Admin/App/blog'
import carousel from './Admin/App/carousel'
import components from './Admin/App/components'
import contacts from './Admin/App/contacts'
import contents from './Admin/App/contents'
import menus from './Admin/App/menus'
import menuTypes from './Admin/Defines/menu_types'
import modLeads from './Admin/App/mod_leads'
import references from './Admin/App/references'
import socialMedia from './Admin/App/socialmedia'
import products from './Admin/App/products'
import productItems from './Admin/App/product_items'
import productCategories from './Admin/App/product_categories'

/* App Defines */

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    users,
    userTypes,
    smtpConfig,
    abilities,
    cropperUploads,
    fileUpload,
    about,
    brands,
    blogCategories,
    blog,
    carousel,
    components,
    contacts,
    contents,
    menus,
    menuTypes,
    modLeads,
    references,
    socialMedia,
    products,
    productItems,
    productCategories,
  },
  strict: process.env.DEV,
})
